<template>
  <div class="pa-1" style="max-height: 550px; overflow-y: auto">
    <div
      v-for="(msg, idx) in chat"
      :key="idx"
      ref="lastMessage"
      class="d-flex mb-3"
      :class="msg.role === 'user' ? 'justify-end' : 'justify-start'"
    >
      <div
        class="d-flex flex-column"
        :style="msg.role === 'assistant' ? 'max-width: 100%' : 'max-width: 80%'"
      >
        <v-sheet
          :color="msg.role === 'user' ? 'grey-lighten-4' : ''"
          rounded="lg"
          class="pa-3"
        >
          <div
            v-if="msg.response_type !== 'post' && msg.response_type !== 'ideas'"
          >
            <!-- <v-img
                      v-if="msg.role === 'assistant'"
                      width="20"
                      class="mb-2"
                      :src="require('@/assets/logo/logo-dark.svg')"
                    ></v-img> -->
            <div
              class="text-body-2"
              v-html="
                msg.role === 'user'
                  ? msg.content?.replace(/\n/g, '<br>')
                  : linkify(assistantResponse(msg).replace(/\n/g, '<br>'))
              "
            ></div>
            <div
              v-if="msg.sources?.length > 0"
              class="d-flex flex-column mt-2"
              style="gap: 5px"
            >
              <p style="font-size: 10pt; max-width: 100%">
                Add link to your post?
                {{
                  media[0]?.type === "url"
                    ? `Current link: ${media[0].url}`
                    : ""
                }}
              </p>
              <div v-if="msg.sources?.length > 0">
                <v-card
                  @click="useSource(msg.sources[0])"
                  class="bg-smoke pa-2"
                  variant="text"
                  :loading="msg.sources[0].loading"
                  style="
                    font-size: 10pt;
                    display: flex;
                    align-items: center;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 200px;
                  "
                >
                  <v-icon size="12" class="mr-2" color="primary">{{
                    msg.sources[0]?.url === media[0]?.url
                      ? "mdi-check-circle"
                      : "mdi-link-variant"
                  }}</v-icon>
                  {{ msg.sources[0].url }}
                </v-card>
              </div>

              <v-expand-transition>
                <div
                  v-if="showSources"
                  style="gap: 5px"
                  class="d-flex flex-column"
                >
                  <v-card
                    @click="useSource(source)"
                    class="bg-smoke pa-2"
                    variant="text"
                    v-for="source in (msg.sources || []).slice(1)"
                    :loading="source.loading"
                    :key="source.url"
                    style="font-size: 10pt; display: flex; align-items: center"
                  >
                    <v-icon size="12" class="mr-2" color="primary">{{
                      source.url === media[0]?.url
                        ? "mdi-check-circle"
                        : "mdi-link-variant"
                    }}</v-icon>
                    {{ source.url }}
                  </v-card>
                </div>
              </v-expand-transition>

              <v-btn
                variant="text"
                size="small"
                v-if="msg.sources?.length > 1"
                @click="showSources = !showSources"
                >{{ showSources ? "Hide sources" : "See all sources" }}</v-btn
              >
            </div>
            <div
              v-if="
                msg.handoff &&
                msg.handoffDetails.find((h) => h.step === idx)?.to
              "
              class="text-caption mt-2 text-grey-darken-1 d-flex align-center"
            >
              <v-icon size="16" class="mr-2" color="primary"
                >mdi-transfer</v-icon
              >
              Handed off to
              <span class="font-weight-medium ml-1">
                {{ msg.handoffDetails.find((h) => h.step === idx).to }}
              </span>
            </div>
            <!-- <div v-if="msg.response_type" class="mt-2">
                      <v-chip size="x-small" color="info" variant="flat">
                        {{ msg.response_type }}
                      </v-chip>
                    </div> -->
          </div>
          <div v-else-if="msg.response_type === 'post'">
            <div class="d-flex align-center mb-2">
              <v-icon color="green" size="15" class="mr-2"
                >mdi-check-circle</v-icon
              >
              <span class="text-caption text-grey-darken-1">Updated Post</span>
              <!-- <v-tooltip text="Rollback to this post" location="top">
                <template #activator="{ props }">
                  <v-btn
                    class="ml-2"
                    v-bind="props"
                    @click="
                      $store.commit('setPostVariationText', {
                        index: $store.state.post.tab,
                        text: msg.post_content,
                      })
                    "
                    icon="mdi-history"
                    size="x-small"
                    variant="text"
                  ></v-btn>
                </template>
              </v-tooltip> -->
            </div>
            <!-- <div
                    class="text-body-2 mb-3"
                    v-html="
                      formatPostContent(
                        msg.post_content || msg.content[0]?.text
                      )
                    "
                  ></div> -->
            <div class="text-body-2 mb-3">
              {{ assistantResponse(msg) }}
            </div>

            <div class="d-flex mt-4" v-if="msg.sources?.length > 0">
              <v-icon color="grey" class="mr-3">mdi-arrow-right-bottom</v-icon>
              <div class="d-flex flex-column mt-1" style="gap: 5px">
                <p style="font-size: 10pt; font-weight: 600" class="mb-2">
                  Add link to your post?

                  {{
                    media[0]?.type === "url"
                      ? `Current link: ${media[0].url}`
                      : ""
                  }}
                </p>

                <div v-if="msg.sources?.length > 0">
                  <v-card
                    @click="useSource(msg.sources[0])"
                    class="bg-smoke pa-2"
                    variant="text"
                    :loading="msg.sources[0].loading"
                    style="font-size: 10pt; display: flex; align-items: center"
                  >
                    <v-icon size="12" class="mr-2" color="primary">{{
                      msg.sources[0]?.url === media[0]?.url
                        ? "mdi-check-circle"
                        : "mdi-link-variant"
                    }}</v-icon>
                    {{ msg.sources[0].url }}
                  </v-card>
                </div>

                <v-expand-transition>
                  <div
                    v-if="showSources"
                    style="gap: 5px"
                    class="d-flex flex-column"
                  >
                    <v-card
                      @click="useSource(source)"
                      class="bg-smoke pa-2"
                      variant="text"
                      v-for="source in (msg.sources || []).slice(1)"
                      :loading="source.loading"
                      :key="source.url"
                      style="
                        font-size: 10pt;
                        display: flex;
                        align-items: center;
                      "
                    >
                      <v-icon size="12" class="mr-2" color="primary">{{
                        source.url === media[0]?.url
                          ? "mdi-check-circle"
                          : "mdi-link-variant"
                      }}</v-icon>
                      {{ source.url }}
                    </v-card>
                  </div>
                </v-expand-transition>

                <v-btn
                  variant="text"
                  size="small"
                  v-if="msg.sources?.length > 1"
                  @click="showSources = !showSources"
                  >{{ showSources ? "Hide sources" : "See all sources" }}</v-btn
                >
              </div>
            </div>
            <!-- <v-divider></v-divider>
                  <div
                    class="d-flex justify-space-between pt-4"
                    style="gap: 5px"
                  >
                    <v-btn
                      variant="text"
                      size="small"
                      @click="
                        copyToClipboard(
                          msg.post_content || msg.content[0]?.text
                        )
                      "
                    >
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                    <v-btn
                      color="primary"
                      size="small"
                      variant="text"
                      @click="
                        useContent(
                          msg.post_content || msg.content[0]?.text,
                          null
                        )
                      "
                      class="mr-2"
                    >
                      <v-icon size="16" class="mr-1">mdi-arrow-right</v-icon>
                      Use
                    </v-btn>
                  </div> -->
          </div>
          <div v-else-if="msg.response_type === 'ideas'">
            Here are some ideas:
          </div>
        </v-sheet>

        <!-- Ideas below the sheet (only for assistant messages with ideas) -->
        <div
          v-if="msg.role === 'assistant' && msg.response_type === 'ideas'"
          class="mt-2"
          style="max-width: 100%"
        >
          <div v-for="(id, index) in msg.ideas || []" :key="index">
            <v-list-item
              class="pa-2 my-1 text-left"
              color="primary"
              variant="flat"
              @click="useIdea(id)"
            >
              <div class="d-flex align-center">
                <v-icon size="13" class="mr-2" color="primary"
                  >mdi-lightbulb-outline</v-icon
                >
                {{ id.title }}
              </div>
              <div class="pa-2 d-flex" style="gap: 5px">
                <v-btn
                  size="small"
                  color="accent"
                  @click="sendMessage('Write a post about ' + id.title)"
                  >Write post</v-btn
                >
                <v-btn
                  v-if="!id.saved"
                  variant="text"
                  size="small"
                  color="accent"
                  @click="saveIdea(id)"
                  >Save for later</v-btn
                >
                <p v-if="id.saved">Saved</p>
              </div>
            </v-list-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { agent } from "@/mixins/agent";

export default {
  mixins: [agent],
  computed: {
    media() {
      return this.$store?.state?.post?.media || [];
    },
  },
  data() {
    return {
      showSources: false,
    };
  },
  methods: {
    useSource(source) {
      this.$emit("useSource", source);
    },
    assistantResponse(msg) {
      try {
        const text = msg?.content?.[0]?.text;
        if (!text) {
          return "";
        }
        const parsed = JSON.parse(text);
        return parsed?.response || "";
      } catch (error) {
        console.warn("Failed to parse assistant response", error);
        return "";
      }
    },
    linkify(t) {
      if (!t) return "";
      return t
        .replace(/(https?:\/\/[^\s<>"')]+|www\.[^\s<>"')]+)/gi, (m) => {
          // strip trailing punctuation
          const clean = m.replace(/[).,!?:]+$/, "");
          const href = clean.startsWith("http") ? clean : `https://${clean}`;
          return `<a href="${href}" target="_blank" rel="noopener noreferrer">${clean}</a>`;
        })
        .replace(/\n/g, "<br>");
    },
  },
};
</script>
